import { ExternalProductSearch } from '@/@types';

const spotify = (token) => {
  const _request = async ({ url, data, params }: { url: string; data?: any; params?: any }) => {
    const searchParams = new URLSearchParams(params).toString();
    return fetch(`https://api.spotify.com${url}?${searchParams}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }).then((res) => {
      return res.json();
    });
  };

  const suggestions = async () => {
    return _request({
      url: '/v1/users/spotify/playlists/356RdloI1Y4ozLdUTh0FAU/tracks',
      params: {
        offset: 0,
        limit: 18,
      },
    }).then(({ items }) => {
      return items.map((result) => {
        return {
          name: result.track.name,
          image: result.track.album?.images?.at(0)?.url,
          details: [result.track.artists?.at?.(0)?.name, result.track.album?.name].filter(Boolean).join(' - '),
          externalId: result.track.id,
          type: 'music',
          url: result.track.external_urls?.spotify,
        };
      }) as ExternalProductSearch[];
    });
  };

  const search = async ({ query }) => {
    return _request({
      url: '/v1/search',
      params: {
        q: query,
        type: 'track',
      },
    }).then(({ tracks }) => {
      return tracks.items.map((result) => {
        return {
          name: result.name,
          image: result.album?.images?.at(0)?.url,
          details: [result.artists?.at?.(0)?.name, result.album?.name].filter(Boolean).join(' - '),
          externalId: result.id,
          type: 'music',
          url: result.external_urls?.spotify,
        };
      }) as ExternalProductSearch[];
    });
  };
  return {
    _request,
    search,
    suggestions,
  };
};

export default spotify;
